module.exports = __webpack_public_path__ + "static/img/-info.92df123.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/-info.jpg
// module id = oAth
// module chunks = 101